import React from 'react';
import { AppIcon } from '../../components/icons/AppIcon';
import { notify } from '../../utils/toast';

interface ReopenLeadNotificationProps {
    leadName: string;
    onConfirm: () => void;
    onCancel: () => void;
    t: any; // Toast ID
}

export const ReopenLeadNotification: React.FC<ReopenLeadNotificationProps> = ({
    leadName,
    onConfirm,
    onCancel,
    t
}) => {
    return (
        <div className="bg-card rounded-2xl shadow-xl border border-subtle p-5 w-full flex flex-col gap-3 font-sans relative overflow-hidden">
            <div className="flex items-start gap-4">
                <div className="flex-shrink-0 bg-amber-50 text-amber-600 p-2 rounded-xl">
                    <AppIcon name="alert-triangle" className="w-6 h-6" />
                </div>
                <div className="flex-1 min-w-0">
                    <h3 className="text-default font-semibold text-base leading-tight mb-1">Reabrir Negociação?</h3>
                    <p className="text-muted text-sm leading-relaxed">
                        Deseja reabrir a negociação <span className="font-medium text-default">"{leadName}"</span>?
                    </p>
                </div>
                <button
                    onClick={onCancel}
                    className="bg-transparent text-muted hover:text-secondary hover:bg-surface-subtle p-1.5 rounded-lg transition-colors absolute top-3 right-3"
                >
                    <AppIcon name="x" className="w-4 h-4" />
                </button>
            </div>
            <div className="flex items-center justify-end gap-3 mt-1 pl-14">
                <button
                    onClick={onCancel}
                    className="bg-surface-subtle text-default font-medium text-sm px-4 py-2 rounded-xl transition-colors hover:bg-surface-subtle"
                >
                    Cancelar
                </button>
                <button
                    onClick={onConfirm}
                    className="bg-amber-500 text-white font-medium text-sm px-4 py-2 rounded-xl transition-colors hover:bg-amber-600 shadow-sm shadow-amber-200"
                >
                    Sim, Reabrir
                </button>
            </div>
        </div>
    );
};
